import { StateError } from '@/components/app/state-error';
import { StateLoading } from '@/components/app/state-loading';
import { Button } from '@/components/ui/button';
import { useGetAd } from '@/features/meta-ads/api';
import type { Ad } from '@/features/meta-ads/api/types';
import { AdSidePanel } from '@/features/meta-ads/components/ad-side-panel';
import { CreateAdDialog } from '@/routes/_authed/ads/new/-components/create-ad-dialog';
import { useState } from 'react';
import { AdsTable } from './ads-table';

export function CampaignPanel({
  campaignId,
  initialAdId,
  initialEditOpen = false,
}: {
  campaignId: string;
  initialAdId?: string;
  initialEditOpen?: boolean;
}) {
  const [selectedAd, setSelectedAd] = useState<Ad | null>(null);
  const [showLinkedAd, setShowLinkedAd] = useState(Boolean(initialAdId));
  const [createAdOpen, setCreateAdOpen] = useState(false);
  const {
    ad: linkedAd,
    isLoading,
    refetch,
  } = useGetAd(showLinkedAd ? (initialAdId ?? '') : '');
  const backToAds = () => {
    setSelectedAd(null);
    setShowLinkedAd(false);
  };

  if (showLinkedAd && !selectedAd) {
    if (isLoading) return <StateLoading />;
    if (!linkedAd || linkedAd.metaCampaignId !== campaignId)
      return (
        <div className="space-y-4 p-4">
          <Button variant="outline" onClick={backToAds}>
            Back to campaign ads
          </Button>
          <StateError
            message="This ad could not be found in the campaign."
            onRetry={() => void refetch()}
          />
        </div>
      );
  }
  const ad = selectedAd ?? (showLinkedAd ? linkedAd : null);
  if (ad) return <AdSidePanel key={ad.id} ad={ad} onBack={backToAds} />;

  return (
    <>
      <AdsTable
        campaignId={campaignId}
        panel
        initialEditOpen={initialEditOpen}
        onAdSelect={setSelectedAd}
        onNewAd={() => setCreateAdOpen(true)}
      />
      <CreateAdDialog
        campaignId={campaignId}
        open={createAdOpen}
        onOpenChange={setCreateAdOpen}
      />
    </>
  );
}
